import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-cree-bon-liv-negoce',
  templateUrl: './cree-bon-liv-negoce.component.html',
  styleUrls: ['./cree-bon-liv-negoce.component.scss']
})
export class CreeBonLivNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
